import React from 'react'


interface CheckmarkProps {
	className?: string;
	isChecked?: boolean;
}

const Checkmark: React.FC<CheckmarkProps> = ({ className, isChecked }) => (
	<div className={`flex justify-center items-center my-auto font-bold text-center h-[25px] w-[25px] ${isChecked ? 'bg-green-500' : 'bg-white'} rounded ${className}`}>
		{isChecked ? '✓' : ''}
	</div>
);

export default Checkmark;